module.exports = __webpack_public_path__ + "static/img/streamMedia-whyneed-img3.d310d07.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/promotion/streamMedia-whyneed-img3.png
// module id = 1096
// module chunks = 1